import MainPage from './MainPage'

export default function App() {
  return <MainPage />
}
